<template lang="pug">
  v-container
    v-layout(column)
      v-flex(v-if="providerIdSelected === 0")
        v-layout(column)
          v-flex.mb-3(
            v-for="provider in providers")
            v-card.provider-card(
              @click="selectProvider(provider.providerId)")
              v-container
                v-layout(row)
                  v-flex(xs2)
                    v-img.mb-3(
                      :src="provider.image"
                      height="50"
                      width="50")
                  v-flex(xs10)
                    div.provider-title {{provider.title}}
                    div.provider-subtitle {{provider.subtitle}}
                    div.provider-subtitle2 {{provider.subtitle2}}
              v-card-actions.white--text.orange.darken-2(v-if="provider.betaMessage")
                div {{provider.betaMessage}}
      v-flex(v-else)
        div(v-if="providerIdSelected === emailAccountTypes.gmail.id")
          gmail-connect(
            @input="closeDrawer"
          )
        div(v-else-if="providerIdSelected === emailAccountTypes.outlook.id")
          outlook-connect(
            @input="closeDrawer"
          )
        div(v-else-if="providerIdSelected === emailAccountTypes.exchange.id")
          exchange-connect(
            @input="closeDrawer"
          )
        div(v-else-if="providerIdSelected === emailAccountTypes.imap.id")
          imap-connect(
            @input="closeDrawer"
          )
</template>

<script>
import { mapState } from 'vuex';
import EMAIL_ACCOUNT_TYPES from './config/email-account-types';
import GmailConnect from './components/Connect/google/GmailConnect';
import OutlookConnectComingSoon from '@/Contacts/components/outlook/OutlookConnectComingSoon';
import OutlookConnect from './components/Connect/outlook/OutlookConnect';
import ImapConnect from './components/Connect/imap/ImapConnect';
import ExchangeConnect from './components/Connect/exchange/ExchangeConnect';
import PROVIDERS from './config/services';


export default {
  components: {
    GmailConnect,
    OutlookConnect,
    OutlookConnectComingSoon,
    ExchangeConnect,
    ImapConnect,
  },
  data() {
    return {
      providerIdSelected: 0,
      emailAccountTypes: EMAIL_ACCOUNT_TYPES,
      providers: PROVIDERS,
    }
  },
  mounted() {
    const emailProviderQuery = this.$route.query['email-provider'];
    const emailProvider = this.emailAccountTypes[emailProviderQuery];
    if (emailProvider) {
      this.providerIdSelected = emailProvider.id;
    }
  },
  watch: {
    isShownConnectionDrawer(newValue) {
      if (!newValue) {
        this.providerIdSelected = 0;
      }
    },
  },
  computed: {
    ...mapState({
      userInformation: state => state.userInformation.user,
      isShownConnectionDrawer: state => state.emailManagement.isShownConnectionDrawer,
    }),
  },
  methods: {
    selectProvider(providerId) {
      this.providerIdSelected = providerId;
    },
    closeDrawer(payload) {
      this.$emit('input', payload);
    },
  }
};
</script>

<style scoped lang="scss">
.provider-title {
  font-size: 26px;
}

.provider-subtitle {
  font-size: 15px;
  color: var(--v-background-darken1);
}

.provider-subtitle2 {
  color: var(--v-background-darken1);
}

.provider-note {
  font-weight: 500;
  font-size: 13px;
  padding-top: 4px;
}

.provider-card {
  cursor: pointer;
  border-radius: 10px;
}
</style>
